import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_INVOICE_PROVIDER_LOADING = 'DELETE_INVOICE_PROVIDER_LOADING';
export const DELETE_INVOICE_PROVIDER_SUCCESS = 'DELETE_INVOICE_PROVIDER_SUCCESS';
export const DELETE_INVOICE_PROVIDER_RESET = 'DELETE_INVOICE_PROVIDER_RESET';
export const DELETE_INVOICE_PROVIDER_REJECT = 'DELETE_INVOICE_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteInvoiceProviderLoading = () => ({ type: DELETE_INVOICE_PROVIDER_LOADING });
export const deleteInvoiceProviderSuccess = (payload) => ({ type: DELETE_INVOICE_PROVIDER_SUCCESS, payload });
export const deleteInvoiceProviderReset = () => ({ type: DELETE_INVOICE_PROVIDER_RESET });
export const deleteInvoiceProviderReject = (payload) => ({ type: DELETE_INVOICE_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteInvoiceProviderRequest = async (getState, id) => {
    const options = await withToken({
        method: Methods.DELETE,
    }, getState);
    return request(`/ProvidersBillingTracking/web/DeleteProvidersBillingTracking?ProvidersTranckingId=${id}`, options);
};